import { Text } from '@app/components/Text/Text';

export { Text };
